import { useEffect, useRef } from 'react';

/**
 * Calls onComplete whenever isCompleted changes.
 */
export function useStepCompletion(
  isCompleted: boolean,
  onComplete: (isComplete: boolean) => void
) {
  const isCompletedPrev = useRef<boolean | null>(null);

  useEffect(() => {
    if (isCompleted !== isCompletedPrev.current) {
      onComplete(isCompleted);
      isCompletedPrev.current = isCompleted;
    }
  }, [isCompleted, onComplete]);
}
